import { render, staticRenderFns } from "./business-profile.vue?vue&type=template&id=1f0b09a6&scoped=true"
import script from "./business-profile.vue?vue&type=script&lang=js"
export * from "./business-profile.vue?vue&type=script&lang=js"
import style0 from "./business-profile.vue?vue&type=style&index=0&id=1f0b09a6&prod&lang=css"
import style1 from "./business-profile.vue?vue&type=style&index=1&id=1f0b09a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0b09a6",
  null
  
)

export default component.exports